import React from "react"
/* custom component */
import Header from "../../../component/Header/Header"
import { PageContainer, LayoutContainer } from "../../../component/Xcomponent"
import BulkUpload from "../../../component/BulkUpload/BulkUpload"

/* actions */

/* otehrs */

export const InstituteTestPricingMasterBulkUpload = props => {
    /* variables */
    return (
        <>
            <Header
                backButton={"/institute-test-pricing-master/list"}
                title={"Institute Test Pricing Master Bulk Update"}
            />
            <PageContainer>
                <LayoutContainer>
                    <BulkUpload master="instituteTestPricing" backUrl="/institute-test-pricing-master/list" apiUrl="test-price/bulk-upload" />
                </LayoutContainer>
            </PageContainer>
        </>
    )
}

export default InstituteTestPricingMasterBulkUpload;
